module.exports = {
  platform: 'voice',
  name: 'Disconnect',
  node: 'chat_disconnect',
  bg: '#FFFFFF',
  note: ''
}
